module.exports = __webpack_public_path__ + "assets/images/cockpit/btn_start_instr_ru.png";